import { IAppBrandingConfig } from '../../interfaces';

export const MAPPING: { [key: string]: keyof IAppBrandingConfig['color'] } = {
    '--ion-color-primary': 'primary',
    '--ion-color-primary-tint': 'primaryVariantAlpha',
    '--ion-color-secondary': 'secondary',
    '--alk-chips-text-color': 'primary',
    '--alk-list-item-background-color-hover': 'primaryVariantGamma',
    '--sfx-web-user-icon-background': 'userIconBackground',
    '--alk-text-selection-background-color': 'primaryVariantGamma',

    // Buttons
    '--alk-button-clear-outline-color': 'primary',
    '--alk-button-clear-outline-hover-color': 'primaryVariantAlpha',
    '--alk-button-pressed': 'primaryVariantDelta',
    '--alk-button-focus-color': 'secondary',
    '--alk-button-close-color': 'informative',

    // Semantics
    '--alk-sell-color': 'sell',
    '--alk-buy-color': 'buy',
    '--alk-processing-color': 'processing',

    // Ag Grid
    '--ag-odd-row-background-color': 'backgroundVariantAlpha',
    '--alk-ag-grid-row-hover': 'gridRowHighlight',
    '--alk-ag-grid-cell-hover': 'gridCellHighlight',
    '--alk-ag-grid-cell-range-hover': 'gridCellRangeHighlight',

    // Input bottom border focus color
    '--alk-input-border-bottom-focus-color': 'inputBottomBorderFocus',
    '--alk-list-menu-border-bottom-focus-color': 'inputBottomBorderFocus',
    '--alk-background-color-field-active': 'inputBackgroundColor',
    '--alk-background-color-field-focus': 'inputBackgroundColorFocus',

    // Calendar
    '--calendar-selected-background': 'primary',
    '--calendar-today-border-color': 'primary',
    '--calendar-focus-background': 'primaryVariantGamma',
    '--calendar-focus-color': 'informative',

    // Progress bar
    '--sfx-web-progess-bar-value': 'primary',
    '--sfx-web-progess-bar-background': 'primaryVariantBeta',

    // Radio button
    '--alk-radio-item-color': 'primary',
    '--alk-radio-hover-color': 'primaryVariantGamma',
    '--alk-radio-focus-color': 'secondary',
    '--alk-radio-pressed-background-color': 'primaryVariantBeta',

    // Toggle
    '--alk-toggle-focus-border-color': 'secondary',
    '--sfx-trading-toggle-background-color': 'tradingToggleBackgroundColor',

    // List Menu
    '--alk-list-menu-focus-color': 'secondary',

    // Checkbox
    '--alk-checkbox-checked-color': 'primary',
    '--alk-checkbox-focus-color': 'secondary',
    '--alk-checkbox-hover-color': 'primaryVariantGamma',
    '--alk-checkbox-pressed-color': 'primaryVariantBeta',

    // Chips
    '--alk-chips-active-background': 'primaryVariantGamma',
};

export const applyColorWithConfig = ({ mapping, elm } = {
    mapping: MAPPING,
    elm: document.body,
}) => (color: IAppBrandingConfig['color']) => {
    for (const cssVariableName in mapping) {
        const colorName = mapping[ cssVariableName ];
        const colorValue = color[ colorName ];

        if (Boolean(colorValue)) {
            elm.style.setProperty(cssVariableName, colorValue);
        }
    }
};

export const applyColorOnBody = applyColorWithConfig();
